import React, {useCallback, useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import withNavigation from "./higher-order/navigation";
import SVG from "react-inlinesvg";
import Zoomer from "./zoomer.js";
import $ from "jquery";
import "../../css/choix-unite-carte.css";
import {setSeoTitle} from "../utils/document";
import {descriptionHebergement} from "../constants/reservation-constants";
import loadingImage from "../../images/loading.svg";
import Translator from "./translator";

function mapStateToProps(state) {
    return {
        entrepriseName: state.entreprise.nom
    };
}

function cap(value, min, max) {
    if (value < min) return min;

    if (value > max) return max;

    return value;
}

function ChoixUniteCarte(props) {
    const mapWrapperRef = useRef(null);
    const transparentImgRef = useRef(null);

    const [mapState, setMapState] = useState({
        zoom: 1, offsetX: 0, offsetY: 0, dragMouseX: 0, dragMouseY: 0, isDragging: false, mapLoaded: false, TEXTS: Translator(props.match.params.language, "TXT_CARTE")
    });

    const getUniteSelector = useCallback((codeUnite) => {
        codeUnite = codeUnite.replace(/_/g, "_x5F_").replace(" ", "_");

        return (`g[id="U_x5F_${ codeUnite }"],
                g[id="U_x5F_${ codeUnite }"] > g:not([id^="T_x5F_"]) *,
                path[id="U_x5F_${ codeUnite }"],
                polygon[id="U_x5F_${ codeUnite }"],
                polyline[id="U_x5F_${ codeUnite }"],
                g[id="U_x5F_${ codeUnite }"] > path,
                g[id="U_x5F_${ codeUnite }"] > rect,
                g[id="U_x5F_${ codeUnite }"] > polygon,
                g[id="U_x5F_${ codeUnite }"] > polyline,
                g[id="U_x5F_${ codeUnite }"] > ellipse,
                g[id="U_x5F_${ codeUnite }"] > circle`);
    }, []);

    const getUniteTextSelector = useCallback((codeUnite) => {
        codeUnite = codeUnite.replace(/_/g, "_x5F_").replace(" ", "_");
        return `text[id="T_x5F_${ codeUnite }"], path[id="T_x5F_${ codeUnite }"], g[id="T_x5F_${ codeUnite }"] *`;
    }, []);

    const drawNewUnites = useCallback(() => {
        const params = new URLSearchParams(props.location.search);
        const idUnite = params.get("idUnite");

        props.unites.forEach((unite) => {
            const isSelected = idUnite === unite.id_unite;

            $(getUniteSelector(unite.code_unite))
                .attr("class", (unite.availabilityLevel || "disponible") + " " + (isSelected ? "selected" : ""))
                .css({fill: ""})
                .off("click touchend");

            $(getUniteTextSelector(unite.code_unite))
                .attr("class", (isSelected ? "selected" : ""))
                .css({
                    fill: "", "stroke-width": ""
                })
                .attr("fill", "")
                .off("click touchend");

            if ((unite.availabilityLevel || "disponible") === "disponible" || (unite.availabilityLevel || "disponible") === "partiellement-disponible") {
                $(getUniteSelector(unite.code_unite)).on("click touchend", () => {
                    props.gotoChoixUnite(unite.type_hebergement, unite.id_type_unite, unite.id_unite);
                });
                $(getUniteTextSelector(unite.code_unite)).on("click touchend", () => {
                    props.gotoChoixUnite(unite.type_hebergement, unite.id_type_unite, unite.id_unite);
                });
            }
        });
    }, [props.unites, getUniteSelector, getUniteTextSelector]);

    const initUnitesPathsOnMap = useCallback(() => {

        drawNewUnites();
    }, [drawNewUnites]);

    const updateMap = useCallback((newClientX, newClientY, newZoom) => {
        const mapWrapper = mapWrapperRef.current;

        if (mapWrapper === undefined || mapWrapper === null) {
            return;
        }

        setMapState((prevState) => {
            const zoom = cap(newZoom, 0, 5);

            const minLeft = -99999;//(mapWrapper.offsetWidth / zoom - mapWrapper.offsetWidth) / 2;
            const maxLeft = 99999;//(mapWrapper.offsetWidth - mapWrapper.offsetWidth / zoom) / 2;
            const minTop = -99999;//(mapWrapper.offsetHeight / zoom - mapWrapper.offsetHeight) / 2;
            const maxTop = 99999;//(mapWrapper.offsetHeight - mapWrapper.offsetHeight / zoom) / 2;

            const left = cap(prevState.offsetX - prevState.dragMouseX + newClientX, minLeft, maxLeft);
            const top = cap(prevState.offsetY - prevState.dragMouseY + newClientY, minTop, maxTop);

            const isDragEnd = prevState.isDragging && newClientX === 0 && newClientY === 0;

            if (isDragEnd) {
                return prevState;
            }

            return {
                ...prevState, offsetX: left, offsetY: top, dragMouseX: newClientX, dragMouseY: newClientY, zoom
            };
        });
    }, []);

    const onMapImageLoad = useCallback(() => {
        initUnitesPathsOnMap();
        setMapState((prevState) => ({
            ...prevState, mapLoaded: true
        }));
    }, [initUnitesPathsOnMap]);

    const onMapDrag = useCallback((e) => {
        updateMap(e.clientX, e.clientY, mapState.zoom);
    }, [updateMap, mapState.zoom]);

    const onMapDragStart = useCallback((e) => {
        e.dataTransfer?.setDragImage(transparentImgRef.current, 0, 0);

        setMapState((prevState) => ({
            ...prevState, dragMouseX: e.clientX, dragMouseY: e.clientY, isDragging: true
        }));
    }, []);

    const onMapDragEnd = useCallback(() => {
        setMapState((prevState) => ({
            ...prevState, isDragging: false
        }));
    }, []);

    const onPlusClick = useCallback(() => {
        updateMap(mapState.dragMouseX, mapState.dragMouseY, mapState.zoom * 1.2);
    }, [updateMap, mapState.dragMouseX, mapState.dragMouseY, mapState.zoom]);

    const onMinusClick = useCallback(() => {
        updateMap(mapState.dragMouseX, mapState.dragMouseY, mapState.zoom / 1.2);
    }, [updateMap, mapState.dragMouseX, mapState.dragMouseY, mapState.zoom]);

    useEffect(() => {
        setSeoTitle(props.entrepriseName, "Réservation", `Carte des ${ descriptionHebergement[props.getTypeHebergement()] }`);

        transparentImgRef.current = new Image(0, 0);
        transparentImgRef.current.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

    }, [props.entrepriseName, props.getTypeHebergement]);

    useEffect(() => {
        if (mapState.mapLoaded) {
            initUnitesPathsOnMap();
        }
    }, [props.unites, mapState.mapLoaded, initUnitesPathsOnMap]);

    return (<div style={ {display: "flex", flexDirection: "column"} }>
        <div className={ "legende" } style={ {paddingTop: "1rem", flexWrap: "wrap"} }>
            <div className={ "legende" }>
                <div className={ "legende disponible" }/>
                <div>{ mapState.TEXTS.LEGENDE_DISPONIBLE }</div>
            </div>
            <div className={ "legende" }>
                <div className={ "legende partiellement-disponible" }/>
                <div>{ mapState.TEXTS.LEGENDE_PARTIELLEMENT_DISPONIBLE }</div>
            </div>
            <div className={ "legende" }>
                <div className={ "legende indisponible" }/>
                <div>{ mapState.TEXTS.LEGENDE_INDISPONIBLE }</div>
            </div>
            <div className={ "legende" }>
                <div className={ "legende reserve" }/>
                <div>{ mapState.TEXTS.LEGENDE_RESERVE }</div>
            </div>
        </div>

        <div id="choix-unite-carte">
            { mapState.mapLoaded && <Zoomer onPlusClick={ onPlusClick } onMinusClick={ onMinusClick } onReset={ onReset => {
                setMapState(prev => ({
                    ...prev, zoom: 1, offsetX: 0, offsetY: 0, dragMouseX: 0, dragMouseY: 0
                }))
            } }/> }

            <div
                ref={ mapWrapperRef }
                style={ {
                    transform: "scale(" + mapState.zoom + ") translate(" + mapState.offsetX + "px, " + mapState.offsetY + "px)", transition: mapState.isDragging ? "initial" : "transform 0.3s ease-out 0s"
                } }

                onDragStart={ onMapDragStart }
                onDrag={ onMapDrag }
                onDragEnd={ onMapDragEnd }
                draggable={ true }
                onTouchStart={ (e) => {
                    e.preventDefault();
                    onMapDragStart({clientX: e.targetTouches[0].clientX, clientY: e.targetTouches[0].clientY})
                } }
                onTouchMove={ (e) => {
                    e.preventDefault();
                    onMapDrag({clientX: e.targetTouches[0].clientX, clientY: e.targetTouches[0].clientY})
                } }
                onTouchEnd={ e => {
                    e.preventDefault();
                    onMapDragEnd();
                } }
            >
                { (!props.unites || props.unites.length <= 0) && <div style={ {position: "absolute", margin: 0, zIndex: 999, height: "100%", width: "100%", backgroundColor: "#00000055"} } id="aucune-unite-wrapper">
                    <img style={ {height: "100%", filter: "brightness(0) saturate(100%) invert(90%) sepia(1%) saturate(20%) hue-rotate(290deg) brightness(104%) contrast(100%)"} } src={ loadingImage } alt="chargement"/>
                </div> }
                <SVG src={ props.src } onLoad={ onMapImageLoad }/>
            </div>
        </div>
    </div>);
}

export default withNavigation(connect(mapStateToProps)(ChoixUniteCarte));
